import React, { useReducer } from "react";
import CartContext from "./CartContext";

const defaultCartState = {
  items: [],
  totalAmount: 0,
};

const cartReducer = (state, action) => {
  if (action.type === "ADD") {
    const existingCartItemIndex = state.items.findIndex(
      (item) => item.id === action.item.id
    );

    const existingCartItem = state.items[existingCartItemIndex];
    let updatedItems;

    if (existingCartItem) {
      const newQuantity = existingCartItem.quantity + action.item.quantity;

      // Check if adding exceeds available quantity
      if (newQuantity > action.item.available_quantity) {
        // alert("You’ve reached the maximum stock for this product.");
        return state; // Don't update the cart
      }

      const updatedItem = {
        ...existingCartItem,
        quantity: newQuantity,
      };
      updatedItems = [...state.items];
      updatedItems[existingCartItemIndex] = updatedItem;
    } else {
      if (action.item.quantity > action.item.available_quantity) {
        // alert("Cannot add more than available stock.");
        return state;
      }
      updatedItems = state.items.concat(action.item);
    }
    const updatedTotalAmount =
      state.totalAmount + action.item.price * action.item.quantity;

    return {
      items: updatedItems,
      totalAmount: updatedTotalAmount,
    };
  }


  if (action.type === "REMOVE") {
    console.log("REMOVE action triggered:", action.id);
    console.log("State Items:", state.items);


    // const existingCartItemIndex = state.items.findIndex(
    //   (item) => item.id === action.id
    // );

    const existingCartItemIndex = state.items.findIndex(
      (item) => String(item.id || item.product_id) === String(action.id || action.product_id)
    );


    if (existingCartItemIndex === -1) {
      console.log("Item not found, returning state...")
      return state
    };

    const existingItem = state.items[existingCartItemIndex];
    const updatedTotalAmount = state.totalAmount - existingItem.price;
    let updatedItems;
    if (existingItem.quantity === 1) {
      updatedItems = state.items.filter((item) => (item.id || item.product_id) !== action.id || action.product_id);
    } else {
      const updatedItem = {
        ...existingItem,
        quantity: existingItem.quantity - 1,
      };
      updatedItems = [...state.items];
      updatedItems[existingCartItemIndex] = updatedItem;
    }
    return {
      items: updatedItems,
      totalAmount: updatedTotalAmount,
    };
  }


  if (action.type === "CLEAR_CART") {
    return {
      items: [],
      totalAmount: 0,
    };
  }

  return defaultCartState;
};

const CartProvider = (props) => {
  const [cartState, dispatchCartAction] = useReducer(
    cartReducer,
    defaultCartState
  );

  const addItemToCartHandler = (item) => {
    dispatchCartAction({ type: "ADD", item: item });
  };

  const removeItemfromCartHandler = (id) => {
    dispatchCartAction({ type: "REMOVE", id: id });
  };


  const clearCartHandler = () => {
    dispatchCartAction({ type: "CLEAR_CART" });
  };
  const cartContext = {
    items: cartState.items,
    totalAmount: cartState.totalAmount,
    addItem: addItemToCartHandler,
    removeItem: removeItemfromCartHandler,
    clearCart: clearCartHandler,
   
  };
  return (
    <CartContext.Provider value={cartContext}>
      {props.children}
    </CartContext.Provider>
  );
};
export default CartProvider;